<div class="modal fade" id={{modelId}} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog pdfModalDialog" id="modal">
        <div class="modal-content" id="pdfViewModalBody">
            <div class="modal-body pdfBodyContainer">
                <div class="row modal-heading-row">
                    <div class="row heading-row-right">
                        <img src="../../../../../assets/icons/logo.png" width="35px" height="32px"
                            class="d-inline-block align-top" alt="" loading="lazy" data-dismiss="modal">
                        <div class="modal-Heading">
                            {{title}}
                        </div>
                    </div>
                    <div class="buttonContainer">
                        <img src="../../../../../assets/icons/share.png" width="18px" height="18px"
                            style="cursor: pointer;" class="d-inline-block align-top" alt="" loading="lazy"
                            data-dismiss="modal" (click)="openSendModal()">
                        <img src="../../../../../assets/icons/closeBlack.png" width="22px" height="22px"
                            style="cursor: pointer;" class="d-inline-block align-top" alt="" loading="lazy"
                            data-dismiss="modal">
                    </div>
                </div>
                <hr>
                <div class="" *ngIf="pdfLoading">
                    <ngx-skeleton-loader class="skelton-tiles" count="2" [theme]="{ 
                        'border-radius': '0px',
                        height: '50px',
                        width:'100%'
                      }">
                    </ngx-skeleton-loader>
                </div>
                <div class="p-0" *ngIf="!pdfLoading">
                    <pdf-viewer class="viewer" [src]="pdfSrc" [render-text]="true" [original-size]="false"
                        [fit-to-page]="false">
                    </pdf-viewer>
                </div>
            </div>
        </div>
    </div>
</div>